import axiosInstance from "./baseUrl";

// Get all coupons
export const getAllCouponsSummary = async () => {
  const response = await axiosInstance.get("/v1/coupon/coupon_summary");
  return response.data;
};

// Get all coupons
export const getAllCoupons = async (params: any) => {
  const response = await axiosInstance.get("/v1/coupon/list_coupons", {
    params,
  });
  return response.data;
};

// Get used coupons
export const getUsedCoupons = async (params: any) => {
  const response = await axiosInstance.get("/v1/coupon/used_coupons", {
    params,
  });
  return response.data;
};

// Create a new coupon
export const createCoupon = async (payload: any) => {
  const response = await axiosInstance.post(
    "/v1/coupon/admin/coupons",
    payload
  );
  return response.data;
};

// Update a coupon
export const updateCoupon = async (couponId: string, payload: any) => {
  const response = await axiosInstance.put(
    `/v1/coupon/update/${couponId}`,
    payload
  );
  return response.data;
};

// Delete a coupon
export const deleteCoupon = async (couponId: string) => {
  const response = await axiosInstance.delete(`/v1/coupon/delete/${couponId}`);
  return response.data;
};

// Get a single coupon by ID
export const getCouponById = async (couponId: string) => {
  const response = await axiosInstance.get(`/v1/coupon/${couponId}`);
  return response.data;
};

// Get a single coupon by ID
export const assignCoupon = async (
  couponId: string,
  assignedUserId: string[]
) => {
  const payload = { assignedUserId };
  const response = await axiosInstance.post(
    `/v1/coupon/admin/coupons/${couponId}/assign`,
    payload
  );
  return response.data;
};
